const RESOURCE_NAME = '/access';
import axios from "@/api/http-auth";
import config from "@/config";
const baseURL = config.api.baseURL

export default () => ({
    getAccessRights(userId, objectName, objectId, params) {
        let url = [RESOURCE_NAME, objectName, objectId].filter(Boolean).join('/')
        if(userId > ''){
            url = `/users/${userId}`+url
        }
        return axios.get(url, {params, baseURL});
    },
    updateAccessRights(userId, objectName, objectId, data, params) {
        let url = [RESOURCE_NAME, objectName, objectId].filter(Boolean).join('/')
        if(userId > ''){
            url = `/users/${userId}`+url
        }
        return axios.post(url, data, {params, baseURL});
    },
});